import {
  HeaderListWrapper,
  HeaderListLabel,
  HeaderTags,
  TextButton,
  HeaderListLabelWrapper
} from './HeaderList.styles'
import { HeaderListTypes } from './HeaderList.types'
import IconButton from '../IconButton/IconButton'
import useId from '../../hooks/useId'
import Icon from '../Icon'

const HeaderList = ({
  id = 'HeaderList',
  iconHeader,
  iconLabel,
  emoji,
  iconLabelPosition = 'after',
  buttonHeader,
  tags = [],
  label,
  hidden = false,
  styles,
  'data-testid': testid = 'header',
  ...props
}: HeaderListTypes) => {
  const { getTestId } = useId(testid)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleClick = (event: any, actions: any) => {
    event.preventDefault()
    event.stopPropagation()
    if (actions) {
      actions()
    }
  }
  const isTagsHeader = tags.length > 0
  const labelWrapperFlexDirection =
    iconLabelPosition === 'before' ? 'row' : 'row-reverse'
  const hasIconLabel = !!iconLabel?.length || !!emoji?.length
  return !hidden ? (
    <HeaderListWrapper
      sx={styles}
      id={`${id}-heading-wrapper`}
      className="HeaderListWrapper"
      data-testid={getTestId()}
      {...props}>
      {isTagsHeader ? (
        <HeaderTags items={tags} data-testid={getTestId('tags')} />
      ) : (
        <HeaderListLabelWrapper
          hasIconLabel={hasIconLabel}
          iconLabelPosition={labelWrapperFlexDirection}
          className="header-list-label-wrapper">
          {iconLabel && <Icon name={iconLabel} />}
          {emoji && <span className="emoji">{emoji}</span>}
          <HeaderListLabel
            id={`${id}-heading-text`}
            className="HeadingText"
            value={label}
            data-testid={getTestId('label')}
          />
        </HeaderListLabelWrapper>
      )}
      {iconHeader && (
        <div className="IconHeaderContainer">
          <span>{iconHeader?.label}</span>
          <IconButton
            data-testid={getTestId('button')}
            onClick={(event) =>
              handleClick(event, iconHeader?.iconButton?.actions)
            }
            {...iconHeader?.iconButton}
          />
        </div>
      )}
      {buttonHeader && (
        <TextButton onClick={buttonHeader.onClick}>
          {buttonHeader.label}
        </TextButton>
      )}
    </HeaderListWrapper>
  ) : null
}

export default HeaderList
